import React, { useRef } from "react";
// import domToImage from "dom-to-image-more";
import * as htmlToImage from "html-to-image";
import { FaTimes, FaDownload } from "react-icons/fa";
import classNames from "classnames";

const ImageModalTemplate = ({ onClose, children, downloadName = "image", classNameCard }) => {
	const elementRef = useRef(null);

	const handleDownload = (e) => {
		if (elementRef.current) {
			htmlToImage
				.toPng(elementRef.current, {
					backgroundColor: "#ffffff", // Imposta uno sfondo bianco per evitare trasparenze
					pixelRatio: 4, // Migliora la qualità raddoppiando la densità dei pixel
				})
				.then((dataUrl) => {
					const link = document.createElement("a");
					link.href = dataUrl;
					link.download = `${downloadName}.png`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			// .catch((error) => {
			// 	console.error("Errore durante il download dell'immagine:", error);
			// });
		}
	};

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ">
			<div className="bg-white rounded-lg shadow-lg  !w-[650px] !max-h-[90%] !max-w-[95%] overflow-y-scroll p-6 pt-10 relative">
				{/* Pulsante per il download */}
				<button
					id="download"
					aria-label="Scarica"
					onClick={handleDownload}
					className="absolute top-2 left-2 text-gray-600 hover:text-gray-800 flex items-center gap-2"
				>
					<FaDownload size={20} />
					Scarica
				</button>

				{/* Pulsante Chiudi */}
				<button
					id="close"
					aria-label="Chiudi"
					onClick={onClose}
					className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
				>
					<FaTimes size={24} />
				</button>

				{/* Contenitore principale */}
				<div
					ref={elementRef}
					className="w-[600px] h-[820px] bg-gray-100 rounded-lg shadow-lg flex flex-col p-6"
				>
					{/* Header */}
					<div className="w-full bg-blue-600 text-white text-center py-4 mb-2 rounded-lg shadow">
						<h1 className="text-2xl font-bold break-words">
							Sistema di Monitoraggio, Informazione ed Allerta Comune di Atri
						</h1>
						<p className="text-md mt-1">A cura di Protezione Civile ANA Atri</p>
					</div>

					{/* Card */}
					<div
						className={classNames(
							`w-full flex-grow p-6 rounded-lg shadow-lg border-2 `,
							classNameCard
						)}
					>
						{children}
					</div>
					{/* Footer */}
					<div className="w-full bg-blue-600 text-white text-center my-2 py-3 rounded-lg shadow text-lg">
						SMIAA.ProtezioneCivileAnaAtri.it
					</div>
				</div>
			</div>
		</div>
	);
};

export default ImageModalTemplate;
